// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6edb76e2","header":"_41da8d8e","copy":"_d3e43f4","dot":"_1e5a65ee","isSoldDot":"_efbd63a0","isOnHoldDot":"_4c4dfb5a","isSold":"_a6d30b3f","isOnHold":"_d311f985"};